import React from 'react';
import './style.css';

const Checkmark = () => (
  <div className="checkmark" />
);

export default Checkmark;
